import { CreatorProfileInstagram, HubCoreService, LogService } from '@hub/shared'
import { useCallback, useEffect, useMemo, useState } from 'react'

export const useFetchAllProfiles = (squidId: string | undefined) => {
  const hubCoreService = useMemo(() => new HubCoreService(), [])
  const logService = useMemo(() => new LogService(), [])
  const [profiles, setProfiles] = useState<CreatorProfileInstagram[]>([])
  const [profilesLoading, setProfilesLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const fetchAllProfiles = useCallback(async () => {
    if (!squidId) return

    setProfilesLoading(true)
    setError(null)

    try {
      let page = 1
      let allProfiles: CreatorProfileInstagram[] = []
      let hasMore = true

      while (hasMore) {
        const response = await hubCoreService.getCreatorProfileBySquidId(squidId, false, page, 10)

        if (!response?.length) {
          hasMore = false
        } else {
          allProfiles = [...allProfiles, ...response]
          page++
        }
      }

      setProfiles(allProfiles)

      return allProfiles
    } catch (err) {
      logService.error({ message: 'Error on get creator profile', error })
    } finally {
      setProfilesLoading(false)
    }
  }, [squidId])

  return {
    profiles,
    profilesLoading,
    error,
    fetchAllProfiles,
    setProfiles,
  }
}
